import {Component, OnDestroy} from '@angular/core';
import { NbThemeService } from '@nebular/theme';

import { LocalDataSource } from 'ng2-smart-table';

import swal from 'sweetalert2';
import { plainToClass } from 'class-transformer';
import { ApiService } from '../../shared/api.service';
import { Device } from '../../shared/data/device';



@Component({
  selector: 'ngx-device',
  styleUrls: ['./device.component.scss'],
  templateUrl: './device.component.html',
})
export class DeviceComponent implements OnDestroy {

  private alive = true;

  settings = {
    actions: {
      columnTitle: '',
      position: 'left',
      add: false,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmCreate: true,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: true,
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      id: {
        title: 'ID',
        type: 'number',
        editable: false,
        addable: false,
        filter: false,
      },
      name: {
        title: 'Nom de l\'appareil',
        type: 'text',
      },
      date_create: {
        title: 'DateCréation',
        type: 'text',
      },
      date_last_visit: {
        title: 'DernièreVisite',
        type: 'text',
      },
      browser: {
        title: 'Navigateur',
        type: 'text',
      },
      city: {
        title: 'Ville',
        type: 'text',
      },
      country_name: {
        title: 'Pays',
        type: 'text',
      },
      ipv4: {
        title: 'AdresseIP',
        type: 'text',
      },
      type: {
        title: 'Appareil',
        type: 'text',
      },
      os: {
        title: 'Système',
        type: 'text',
      },
      nameUser: {
        title: 'Compte Utilisateur',
        type: 'text',
      },
      firebase_token: {
        title: 'Firebase Token',
        type: 'text',
      },
    },
    noDataMessage: 'Aucun appareil trouvé',
    pager: {
      display: true, // pour gerer la pagination
      perPage: 10,
    },
    mode: 'external',
  };

  source: LocalDataSource = new LocalDataSource();

  constructor(private apiService:ApiService,) {

    this.getDevices();

  }

  getDevices() {
  
    this.apiService.getDevices().subscribe( devices => {

        this.source.load(devices);
        this.source.setSort([{ field: 'date_last_visit', direction: 'desc' }]);

    });


  }



  ngOnDestroy() {
    this.alive = false;
  }

  onDelete(event): void {

    let device: Device;
    device = event.data;

    swal({
      title: 'Suppression appareil',
      text: 'Voulez - vous vraiment supprimer l\'appareil No: ' + device.id + ' ? Vous ne pourrez plus annuler l\'opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        return this.apiService.deleteDevice(device).subscribe( data => {
          // event.confirm.resolve(event.newData);
          // event.confirm.resolve();
          this.source.remove(event.data);
          // this.dialogIsNotShow = true;

        });

      },
    }).then((result) => {

      if (result.value) {

        //this.sharedMethods.sweetalert('success', 'Appareil supprimé avec succèss', '');
        // this.dialogIsNotShow = true;

      }

    });

  }

  onCreate(event): void {

    if (window.confirm('Are you sure you want to create?')) {
     /* let user  = new User();
        user.FirstName = event.newData.FirstName;
        user.LastName = event.newData.LastName;
        user.Username = event.newData.Username;
        user.Email = event.newData.Email;
        user.Age = event.newData.Age;
        user.Activated = event.newData.Activated;

        this.databaseService
            .connection
            .then(() => user.save())
            .then(user => {
                event.newData.Id = user.Id;
                event.confirm.resolve(event.newData);
            })
 */


    } else {
      event.confirm.reject();
    }

  }

  onSave(event): void {

    // let nom = event.data.name;
    let device = new Device;
    device = plainToClass(Device, event.data as object);
  
    swal({
      title: 'Modification du nom de l\'appareil ',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: false,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'ok',
      showLoaderOnConfirm: true,
      preConfirm: (nom) => {
  
        if (nom) {
          
            device.name = nom;
            return this.apiService.save(device).subscribe( data => {
              // event.confirm.resolve(event.newData);
              this.source.update(event.data, data);
  
              // this.source.remove(event.data);
            });
  
  
        }
  
      },
      allowOutsideClick: () => !swal.isLoading(),
    }).then((result) => {
  
      if (result.value) {
        // alert(result.value);
      }
  
    });

  }


}
